<script setup lang="ts">
import { notifications } from '@/composables';
import NotificationTile from './notifications/NotificationTile.vue';
</script>

<template>
    <template v-for="n in notifications" :key="n.id">
        <NotificationTile :info="n"></NotificationTile>
    </template>
</template>

<style scoped></style>
